<template>
  <div class="comments-list w-full min-w-0 max-w-full">
    <template v-if="isMobileDevice">
      <div v-if="items.length">
        <DealershipApplicationCommentCard
          v-for="item of items"
          :key="item.id"
          :created-at="item.createdAt"
          :body="item.body"
          :user-data="item.userData"
          :status-at-event-label="item.statusAtEventLabel"
        />
      </div>
      <SkeletonLoaderCard v-else :table-headers="tableHeaders" />
    </template>

    <OurTable
      v-else
      :headers="tableHeaders"
      :items="items"
      :table-fixed="false"
      class="comments-list-table"
    >
      <template #cell-userData="{ value }">
        <div class="flex flex-col gap-1">
          <div>{{ value.fullName }}</div>
          <div>{{ value.email }}</div>
        </div>
      </template>
    </OurTable>
    <OurPagination
      v-if="isMoreThanOnePage"
      :current-page="paginationData.currentPage"
      :per-page="paginationData.perPage"
      :total="paginationData.total"
      @pageChange="onPageChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DealershipApplicationCommentCard from "./DealershipApplicationCommentCard.vue";
import SkeletonLoaderCard from "@/ui/loader/SkeletonLoaderCard.vue";

export default {
  name: "DealershipApplicationsCommentsList",

  components: {
    DealershipApplicationCommentCard,
    SkeletonLoaderCard,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    paginationData: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),

    tableHeaders() {
      return [
        {
          value: "createdAt",
          text: this.$t("dealershipApplications.commentCreatedAt"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[10rem] min-w-[7rem]",
        },
        {
          value: "body",
          text: this.$t("label.comment"),
          thClass: "w-[8rem]",
          tdClass: "max-w-[24rem] min-w-[20rem] whitespace-pre-wrap",
        },
        {
          value: "userData",
          text: this.$t("label.userData"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[10rem] min-w-[7rem]",
        },
        {
          value: "statusAtEventLabel",
          text: this.$t("dealershipApplications.statusWhenCommentAdded"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[7rem] min-w-[5rem]",
        },
      ];
    },

    isMoreThanOnePage() {
      return this.paginationData.lastPage > 1;
    },

    routeCommentsPage() {
      return Number.parseInt(this.$route.query.commentsPage, 10) || 1;
    },
  },

  watch: {
    routeCommentsPage(newPage) {
      if (newPage !== this.paginationData.currentPage) {
        this.$emit("pageChange", newPage);
      }
    },
  },

  methods: {
    onPageChange(page) {
      this.$emit("pageChange", page);

      if (page !== this.routeCommentsPage) {
        const query = { ...this.$route.query };

        delete query.commentsPage;

        const nextQuery = page === 1 ? query : { ...query, commentsPage: page };

        this.$router.push({ name: this.$route.name, query: nextQuery });
      }
    },
  },
};
</script>
